import { render, staticRenderFns } from "./CarrierHeldSchedules.vue?vue&type=template&id=1bd036e8&scoped=true&"
import script from "./CarrierHeldSchedules.vue?vue&type=script&lang=js&"
export * from "./CarrierHeldSchedules.vue?vue&type=script&lang=js&"
import style0 from "./CarrierHeldSchedules.vue?vue&type=style&index=0&id=1bd036e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd036e8",
  null
  
)

export default component.exports